import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import Awesome from "../POST_INSTANCE/Judgement";
import Stats from "../POST_INSTANCE/Stats";
import FeedInstance from "./FeedInstance";
 
class Feeds
{
    private conquer     : CONQUER;
    public pool         : any = [];
 
    constructor( conquer:CONQUER )
    {
        this.conquer    = conquer;
    }

    public async get( vars:any ) : Promise<any>
    {
        let data : any = await this.conquer.do( ACTIONS.FEED_GET, vars );

        for( let n in data ) new FeedInstance( this.conquer, data[n] );
 
        return Promise.resolve(  );
    }

    public async getOne( vars?:any ) : Promise<any>
    {
        vars = vars || {};

        if( !vars.ownerID ) vars.ownerID = this.conquer.Avatars.ME.avatarID;
        if( !vars.type ) vars.type = "posts";

        let data : any = await this.conquer.do( ACTIONS.FEED_GETONE, vars );

        if( !data ) return Promise.resolve( null );

        let feed = new FeedInstance( this.conquer, data );
 
        return Promise.resolve( feed );
    }




 
};

export default Feeds;